import React from 'react';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';

interface GradientBorderButtonProps {
	label: string;
	color?: string;
	onClick?: () => void;
	padding?: string;
	type?: any;
	borderRadius?: string;
	fontSize?: string;
	backgroundColor?: string;
	backgroundImage?: string;
	startIcon?: React.ReactNode;
}

const GradientBorderButton: React.FC<GradientBorderButtonProps> = ({
	label,
	color,
	onClick,
	padding,
	type,
	borderRadius,
	fontSize,
	backgroundColor,
	backgroundImage,
	startIcon,
}) => {
	return (
		<Button
			sx={{
				padding: '2px',
				borderRadius: borderRadius || '30px',
				background: 'linear-gradient(90deg, #9149ff, #e600ff)',
				display: 'inline-block',
				textTransform: 'none',
				minWidth: 0,
			}}
			type={type}
			onClick={onClick}
		>
			<Box
				sx={{
					backgroundColor: backgroundColor || '#121212',
					backgroundImage:
						backgroundImage ||
						'linear-gradient(rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.16))',
					borderRadius: borderRadius || '30px',
					padding: padding || '6px 16px',
					color: color || '#fff',
					fontSize: fontSize || '14px',
					fontWeight: 'bold',
					display: 'flex',
					alignItems: 'center',
					gap: '6px',
				}}
			>
				{startIcon}
				{label}
			</Box>
		</Button>
	);
};

export default GradientBorderButton;
